import React, { useEffect, useState } from 'react'
import Item from '../Item/Item'
import { backend_url } from '../../App';

const RelatedProducts = ({category, id}) => {

  const [related, setRelated] = useState([]);

  useEffect(() => {
    fetch(`${backend_url}/relatedproducts`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ category: category }),
    })
    .then((res) => res.json())
    .then((data) => setRelated(data))
  }, [category])

  return (
    <div className='flex flex-col items-center py-16 pb-24 px-[8%]'>
      <div className="text-center mb-10">
        <span className="inline-block bg-[rgba(0,212,255,0.1)] text-[#00d4ff] border border-[rgba(0,212,255,0.25)] px-4 py-[5px] rounded-full text-xs font-bold tracking-[2px] uppercase mb-3">You May Also Like</span>
        <h1 className="text-4xl font-black text-white mb-2">Related <span className="bg-gradient-to-br from-[#00d4ff] to-[#7c3aed] bg-clip-text text-transparent">Products</span></h1>
        <div className="w-16 h-[3px] bg-gradient-to-r from-[#00d4ff] to-[#7c3aed] rounded-full mx-auto" />
      </div>
      <div className="w-full flex flex-wrap justify-center gap-6 max-w-[1400px]">
        {related.filter(item => item.id !== id).map((item, index) => (
          <Item key={index} id={item.id} name={item.name} image={item.image} new_price={item.new_price} old_price={item.old_price} />
        ))}
      </div>
    </div>
  )
}

export default RelatedProducts
